import { StateSchema } from 'app/providers/StoreProvider';

export const getAddInventoryItemMode = (state: StateSchema) =>
    state.addInventoryItem.addItemMode;

export const getAddInventoryIsLoading = (state: StateSchema) =>
    state.addInventoryItem.isLoading;
